/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assistant.rpc.ChatRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const chatRpc = {
  serviceName: 'com.hubspot.academy.assistant.rpc.ChatRpc',
  rpcName: 'chat',
  auth: 'app',
  fingerprint: '0oStvwqbwWQVEuD-1W-t4lpROKU44M5j',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getEncryptedConfigRpc = {
  serviceName: 'com.hubspot.academy.assistant.rpc.ChatRpc',
  rpcName: 'getEncryptedConfig',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAtjEM5KRv1CZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getEncryptedConfigWithModifiedSystemPromptRpc = {
  serviceName: 'com.hubspot.academy.assistant.rpc.ChatRpc',
  rpcName: 'getEncryptedConfigWithModifiedSystemPrompt',
  auth: 'app',
  fingerprint: 'WsmtCshR2cktjEM5KRv1CZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSystemPromptRpc = {
  serviceName: 'com.hubspot.academy.assistant.rpc.ChatRpc',
  rpcName: 'getSystemPrompt',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADfGrFQwlYTcpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};